import { northIndiaDistricts } from './districts/north';
import { southIndiaDistricts } from './districts/south';
import { eastIndiaDistricts } from './districts/east';
import { westIndiaDistricts } from './districts/west';
import { northeastIndiaDistricts } from './districts/northeast';

export const districts = {
  ...northIndiaDistricts,
  ...southIndiaDistricts,
  ...eastIndiaDistricts,
  ...westIndiaDistricts,
  ...northeastIndiaDistricts
};